import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export const StickyCTA = ({
  showNewImage = false
}) => {
  return <div className="sticky-cta" data-id="element-224">
      <div className="sticky-cta-inner" data-id="element-225">
        <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-226">
          Instant Lipedema Relief or Money Back!
        </h3>
        <div className="product-image mb-4 bg-gray-100 rounded-lg overflow-hidden" data-id="element-227">
          <div className="aspect-w-1 aspect-h-1 relative w-full" style={{
          paddingBottom: '100%'
        }} data-id="element-228">
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center" data-id="element-229">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qmSV4RMimxzM2iJpk7S2Cd/ChatGPT_Image_22_%CE%9D%CE%BF%CE%B5_2025%2C_06_07_46_%CE%BC.%CE%BC..png" alt="Elivara Arm Sculpt Compression Sleeves" className="object-contain h-full w-full" data-id="element-230" />
            </div>
          </div>
        </div>
        <div className="customer-reviews mb-4" data-id="element-231">
          <div className="flex items-center justify-center mb-1" data-id="element-232">
            <div className="flex" data-id="element-233">
              {[1, 2, 3, 4, 5].map((star, index) => <StarIcon key={index} className={`h-5 w-5 ${index < 5 ? 'text-yellow-400' : 'text-gray-300'} fill-current`} data-id="element-234" />)}
            </div>
            <span className="ml-2 text-sm font-semibold" data-id="element-235">4.8 out of 5</span>
          </div>
          <p className="text-center text-sm text-gray-600" data-id="element-236">
            3,791 customer ratings
          </p>
        </div>
        <div className="ratings-breakdown mb-4 px-2" data-id="element-237">
          {[{
          label: '5★',
          percentage: 90
        }, {
          label: '4★',
          percentage: 7
        }, {
          label: '3★',
          percentage: 2
        }, {
          label: '2★',
          percentage: 0
        }, {
          label: '1★',
          percentage: 1
        }].map((rating, index) => <div key={index} className="flex items-center text-sm mb-1" data-id="element-238">
              <span className="w-8" data-id="element-239">{rating.label}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-2.5" data-id="element-240">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
              width: `${rating.percentage}%`
            }} data-id="element-241"></div>
              </div>
              <span className="w-8 text-right" data-id="element-242">{rating.percentage}%</span>
            </div>)}
        </div>
        <a href="https://tryelivara.com/pages/elivara-arm-sculpt-compression#te-featured-product" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center mb-2 block" data-id="element-243">
          CHECK AVAILABILITY →
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-244">
          Limited time offer - Fast FREE shipping across the US
        </p>
      </div>
    </div>;
};